function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { componentsThemeMap, HighlightTable as HighlightTable$1, Div, RichText } from '@cbhq/cdx-components';
import { cellOptions } from './cellOptions.js';
import { jsx } from 'react/jsx-runtime';
const HIGHLIGHT_TABLE_CONTENT_MODEL_ID = 'cdxHighlightTable';
function HighlightTable({
  headline,
  subhead,
  anchor,
  hasSpacingTop,
  hasMobileHorizontalScroll,
  style = 'default',
  tableStyle,
  legalDisclaimer,
  table,
  mobileColumnsVisibility = [],
  columnsWidth = [],
  options,
  columnsVerticalAlignment
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary;
  const mobileVisibility = mobileColumnsVisibility.map(def => def === 'hidden' ? true : false);
  const _richTextToTableDefin = richTextToTableDefinitions(table, {
      mobileVisibility,
      width: columnsWidth
    }, {
      color: foreground,
      secondaryColor: foregroundSecondary
    }, columnsVerticalAlignment),
    columns = _richTextToTableDefin.columns,
    data = _richTextToTableDefin.data;
  if (!columns || !data) return null;
  return /*#__PURE__*/jsx(HighlightTable$1, _objectSpread({
    headline: headline,
    subhead: subhead,
    legalDisclaimer: legalDisclaimer,
    anchor: anchor,
    style: style,
    tableStyle: tableStyle,
    hasSpacingTop: hasSpacingTop,
    hasMobileHorizontalScroll: hasMobileHorizontalScroll,
    data: data,
    columns: columns
  }, options));
}
const richTextToTableDefinitions = (document, columnsConfigs, richtextProps, columnsVerticalAlignment) => {
  const table = document?.content.find(content => content.nodeType === 'table');
  if (!table) return {};
  const tableHeadings = table.content[0].content;
  const hasLabels = tableHeadings[0].nodeType === 'table-header-cell';
  const asColumns = tableHeadings.map((header, index) => {
    let labelText = '';
    if (hasLabels) {
      const labelNode = header.content.find(c => c.nodeType === 'paragraph');
      labelText = labelNode?.content.find(c => c.nodeType === 'text')?.value;
    }
    return {
      label: labelText,
      dataKey: `key-${index}`,
      size: columnsConfigs.width[index],
      hideOnMobile: columnsConfigs.mobileVisibility[index] || false,
      verticalAlignment: columnsVerticalAlignment?.[index] ?? 'center'
    };
  });
  const tableDataRows = hasLabels ? table.content.slice(1) : table.content;
  const asData = tableDataRows.map(row => {
    const columns = row.content;
    const toRichText = columns.map((column, index) => /*#__PURE__*/jsx(Div, {
      flexDirection: "column",
      gap: 3,
      flex: 1,
      children: /*#__PURE__*/jsx(RichText, _objectSpread(_objectSpread({}, richtextProps), {}, {
        content: _objectSpread(_objectSpread({}, column), {}, {
          nodeType: 'document'
        }),
        paragraphSpacingTop: 0,
        richTextOptions: cellOptions
      }))
    }, index));
    return toRichText.reduce((acc, cur, index) => _objectSpread(_objectSpread({}, acc), {}, {
      [`key-${index}`]: cur
    }), {});
  });
  return {
    columns: asColumns,
    data: asData
  };
};
export { HIGHLIGHT_TABLE_CONTENT_MODEL_ID, HighlightTable };
//# sourceMappingURL=HighlightTable.js.map
